import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import LoaderWithProgress from "../../../atoms/loader/LoaderWithProgress.js";
import { invokeGetService, invokePostService } from "../../../../store/global/actions";
import { actionTypeSchema } from '../../../../config/fields';
import { getImageMapData } from "../../../../store/global/selectors";
import FormEditor from "../../../atoms/jsonFormEditor/FormEditor";
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { setImageMapData } from "../../../../store/global/actions";
import { findResponseEventsInTransaction } from '../../../../services/Transaction.js';
import '../style.css';
import { findHelperText, injectInlineHelperText } from '../../../../utils/DashboardBuilder.js';



const useStyles = makeStyles((theme) => ({
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: '0.625rem',
        marginRight: '0.625rem',
    }
}));

export default function AreaProperties({ onClose }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { selectedAreaName, areas } = useSelector(getImageMapData);

    const [schemaValues, setSchemaValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [schema, setSchema] = useState({});

    const selectedArea = areas?.find(ele => ele.name == selectedAreaName);

    useEffect(() => {
        loadClusterlets()
    }, [selectedAreaName])

    const loadClusterlets = () => {
        setLoading(true);
        dispatch(invokeGetService('getBlueprintConstructs', [])).then((response) => {
            if (response.status) {
                const clusterlets = response.data.clusterlets.filter(c => c.type === 2 || c.type === 3);
                const transactions = response.data.transactions.filter(tr => tr.type == 7);
                const views = response?.data?.views;
                const delegates = response.data.clusterlets.filter(c => c.type === 1);
                const events = response.data.events;
                generateFormSchema(transactions, clusterlets, views, delegates, events);
                generateSchemaData(transactions, clusterlets, views, delegates, events);
            }
            setLoading(false);
        })
    }


    const generateSchemaData = (transactions, clusterlets, views, delegates, events) => {
        if (selectedArea) {
            const schemaData = {};
            schemaData.name = selectedArea.name ? selectedArea.name : "";
            schemaData.type = {}
            if (selectedArea.type === "transaction") {
                schemaData.type.transaction = { [selectedArea.transaction]: selectedArea.transaction };
                schemaData.type.transaction.instance = selectedArea.instance ? selectedArea.instance : "";

            }

            if (selectedArea.type === "url") {
                schemaData.type = { url: "url" };

                if (selectedArea.urltype === "url-clusterlet") {
                    schemaData.type.urltype = { "url-clusterlet": "url-clusterlet" };
                    schemaData.type.urltype.clusterlet = selectedArea.clusterlettype ? selectedArea.clusterlettype : "select";
                    schemaData.type.urltype.queryParameters = (selectedArea.queryparams && selectedArea.queryparams?.length > 0) ? selectedArea.queryparams : [{Key:"", Value:""}];
                    
                }

                if (selectedArea.urltype === "url-external") {
                    schemaData.type.urltype = { "url-external": "url-external" };
                    schemaData.type.urltype.url = selectedArea.url ? selectedArea.url : "";
                }

                if (selectedArea.urltype === "url-view") {
                    schemaData.type.urltype = { "url-view": "url-view" };
                    schemaData.type.urltype.viewname = selectedArea.viewname ? selectedArea.viewname : "select";
                    schemaData.type.urltype.instance = selectedArea.instance ? selectedArea.instance : "";
                    schemaData.type.urltype.queryParameters = (selectedArea.queryparams && selectedArea.queryparams?.length > 0) ? selectedArea.queryparams : [{Key:"", Value:""}];
                }
            }

            setSchemaValues(schemaData);

        }
    }

    let options = {
        form_name_root: "imageMapAreaProperty",
        show_errors: "never",

        disable_array_delete_all_rows: true,
        disable_array_delete_last_row: true,
        disable_array_reorder: true,
    }

    const generateFormSchema = (transactions, clusterlets, views, delegates, events) => {
        const typeSchemaObj = actionTypeSchema(transactions, clusterlets, views, delegates, events);
        const formSchema = {
            type: 'object',
            required: ['type', 'name'],
            options: {
                layout: 'grid',
                disable_properties: true,
            },
            properties: {
                name: {
                    title: 'Name',
                    type: 'string',
                    options: {
                        layout: 'grid',
                        grid_columns: 12,
                        disable_properties: true,
                    },
                },
                type: {
                    title: 'Type',
                    type: 'object',
                    oneOf: [...typeSchemaObj],
                    options: {
                        layout: 'grid',
                        disable_properties: true,
                    }
                }
            }
        }

        setSchema(formSchema);
    }


  // Modify query params fields in the form
  const modifyQueryParamsFieldsInForm = () => {
    try {
        
    const containers = document.querySelectorAll('[data-schemapath="imageMapAreaProperty.type.urltype.queryParameters"]');
    if (containers) {
      containers?.forEach((container, index) => {
       
        // 1. Change grid size from col-md-12 → col-md-6
        container.classList.remove("col-md-12");
    
        // 2. Change Add Row button text
        const addBtn = container.querySelector(".json-editor-btn-add");
        if (addBtn) {
          addBtn.title = "";
          const span = addBtn.querySelector("span");
          if (span) span.textContent = " Add query parameter";
        }
    
        // 3. Insert label "Custom arguments" before the table if not present
        if (!document.getElementById(`custom-arguments-label-${index}`)) {
          const table = container.querySelector("table");
          if (table) {
            const label = document.createElement("div");
            label.id = `custom-arguments-label-${index}`;
            label.textContent = "Add more query parameters for the hyperlink";
            label.style.marginBottom = "5px";
            label.style.marginTop = "8px";
            table.parentNode.insertBefore(label, table);
          }
        }
       
     })

    }

    } catch (error) {
        console.error(`Modifying query params fields in the form failed. ${error}`);
    }
  }


    const onChangeJsonEditor = (data) => {
        modifyQueryParamsFieldsInForm();
        // For hide the the title
        const elementToDisable = document.querySelectorAll('.card-title');
        if (elementToDisable) {
            elementToDisable.forEach(element => {
                element.style.display = 'none';
            });
        }


        // Inject the helper text in the form
        const helperText = findHelperText("imagemap_widget", "area_operation")
        injectInlineHelperText({
            formId: "area-properties-form", 
            schemaPath: "imageMapAreaProperty.type.transaction", 
            helperText: helperText
        })
    }

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const customValidation = (data) => {
        var errors = [];
        if (data.name == '') {
            errors.push({
                path: "imageMapAreaProperty.name",
                property: 'format',
                message: "This field cannot be empty"
            });
        }
        
        if(data?.type?.select == "select"){
            errors.push({
                path: 'imageMapAreaProperty.type',
                property: "format",
                isSwitcher: true,
                message: "Type must be selected"
            })
        }

        if(data?.type?.transaction?.select == "select"){
            errors.push({
                path: 'imageMapAreaProperty.type.transaction',
                property: "format",
                isSwitcher: true,
                message: "Transaction must be selected"
            })
        }

        if(data?.type?.transaction?.instance == ""){
            errors.push({
                path: 'imageMapAreaProperty.type.transaction.instance',
                property: "format",
                message: "This field is required"
            })
        }

        if(data?.type?.urltype?.select == "select"){
            errors.push({
                path: 'imageMapAreaProperty.type.urltype',
                property: "format",
                isSwitcher: true,
                message: "This field is required"
            })
        }

        if(data?.type?.urltype?.clusterlet == "select"){
            errors.push({
                path: 'imageMapAreaProperty.type.urltype.clusterlet',
                property: "format",
                message: "This field is required"
            })
        }

        if(data?.type?.urltype?.instance == "" && !("viewname" in data?.type?.urltype)){
            errors.push({
                path: 'imageMapAreaProperty.type.urltype.instance',
                property: "format",
                message: "This field is required"
            })
        }

        if(data?.type?.urltype?.url == ""){
            errors.push({
                path: 'imageMapAreaProperty.type.urltype.url',
                property: "format",
                message: "This field is required"
            })
        }

        if(data?.type?.urltype?.viewname == "select"){
            errors.push({
                path: 'imageMapAreaProperty.type.urltype.viewname',
                property: "format",
                message: "This field is required"
            })
        }


        const isDuplicateArea = areas?.find(area => area.name == data.name && area.name !== selectedAreaName);
        if (isDuplicateArea) {
            errors.push({
                path: "imageMapAreaProperty.name",
                property: 'format',
                message: "Name already exists"
            });
        }

        const isValidName = new RegExp(/^[a-zA-Z0-9_]*$/).test(data.name);
        if (!isValidName) {
            errors.push({
                path: "imageMapAreaProperty.name",
                property: 'format',
                message: "This field cannot contain special characters or white spaces"
            });
        }

        return errors;
    };

    const onUpdateProperties = (data) => {
        const areaData = { name: data.name };
        if (selectedArea) {
            areaData.coords = selectedArea.coords;
            areaData.shape = selectedArea.shape;
            const type = Object.keys(data?.type)[0];

            if (type === 'transaction') {
                areaData.type = 'transaction'; // Controller is using type as event
                areaData.transaction = Object.keys(data?.type?.transaction)[0];
                areaData.instance = data?.type?.transaction?.instance;
            }

            if (type === 'url') {
                areaData.type = 'url';
                const urltype = Object.keys(data?.type?.urltype)[0];
                if (urltype) {
                    const queryParams = data?.type?.urltype?.queryParameters?.filter(item => item?.Key !== "" && item?.Value !== "") || [];
                    areaData.urltype = urltype;
                    if (urltype === 'url-clusterlet') {
                        areaData.clusterlettype = data?.type?.urltype?.clusterlet;
                        areaData.instance = data?.type?.urltype?.instance;
                    }

                    if (urltype === 'url-view') {
                        areaData.viewname = data?.type?.urltype?.viewname;
                        areaData.instance = data?.type?.urltype?.instance;
                    }

                    if( (urltype === 'url-clusterlet' || urltype === 'url-view') &&  queryParams?.length > 0){
                        areaData.queryparams = queryParams;
                    }else{
                        delete areaData.queryparams;
                    }

                    if (urltype === 'url-external') {
                        areaData.url = data?.type?.urltype?.url;
                    }
                }
            }
        }
        const newAreas = areas.map((obj => obj.name === selectedAreaName ? areaData : obj))
        dispatch(setImageMapData({ selectedAreaName: null, areas: [...newAreas] }));
    }

    return (
        <>
            {loading ?
                <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '28vh' }} />
                :
                <Grid container direction={"row"}>
                    <FormEditor editorId={"area-properties-form"} onChangeJsonEditor={onChangeJsonEditor} options={options} schema={schema} onSave={onUpdateProperties} onClose={onClose} schemaValues={schemaValues} validation={validation} action={"edit"} customValidation={customValidation} />
                </Grid>

            }
        </>
    )
}